export const customSessionTimeoutKey = 'customSessionTimeout';
export const APPLICATION_KEY = 'application';

export function getCustomSessionTimeoutKey() {
  return `${APPLICATION_KEY}:${customSessionTimeoutKey}`;
}

export function isSessionTimeoutKey(preference: { key: string }): boolean {
  return preference.key === getCustomSessionTimeoutKey();
}
